import React from 'react';
import Chart from './Chart';
import Grid from './Grid';
import GridColumn from './GridColumn';

class GraphCollectionBlock extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            data: {},
        };
    }

    componentDidMount() {
        fetch(
            `/api/report/graph/${this.props.blockId}/${this.props.languageBranch}/collection`
        )
            .then((response) => response.json())
            .then((data) =>
                this.setState({
                    data,
                    loading: false,
                })
            );
    }

    render() {
        const { loading, data } = this.state;

        if (loading) {
            return <div>Loading....</div>;
        }

        return (
            <Grid>
                {data.graphs.map((graph, index) => (
                    <GridColumn key={index} desktopSpan={data.column}>
                        <Chart
                            type={graph.type}
                            key={index}
                            id={graph.id}
                            title={graph.title}
                            labels={graph.labels}
                            options={graph.options}
                            datasets={graph.datasets}
                            palette={this.props.palette}
                            highlightLastDataEntry={
                                graph.highlightLastDataEntry
                            }
                        />
                    </GridColumn>
                ))}
            </Grid>
        );
    }
}

export default GraphCollectionBlock;
